// Map controls
export function toggleDrawControls(show) {
	const value = show ? '' : 'none';

	getAndSetControl('mapbox-gl-draw_trash', value);
	getAndSetControl('mapbox-gl-draw_polygon', value);
}

function getAndSetControl(controlClass, value) {
	const element = document.getElementsByClassName(controlClass)[0];

	if (element) element.style.display = value;
}
